import React from 'react'
import styles from './styles/NewsBanner.module.scss'

function NewsBanner({ image, title, subtitle, count }) {

    return (
        <div
            className={styles.banner}
            style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
                textAlign: 'center'
            }}>
            <div className={`${styles.bannerContents} container`}>
                <h1>{title}</h1>
                <p>{subtitle}</p>
                {count > 0 && (
                    <div className={styles.countContainer}>
                        <p>Over <span>{count}</span> News posted in past week</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default NewsBanner